import { platformFetch, readEnvelope } from '../../platform/http';

/** 用户 LLM 流量余额；数值由后端以字符串返回，避免 Token 大数精度丢失。 */
export interface LlmTrafficBalance {
  totalGranted: string;
  available: string;
  reserved: string;
  settled: string;
  /** 当日（北京时间）已消耗的免费额度 token 数 */
  freeUsedTokens?: string;
  /** 每日免费额度 token 数（0 表示关闭） */
  freeDailyTokens?: number;
  /** 每 1 积分可兑换的 Token 数 */
  tokensPerCredit?: number;
}

export interface LlmTrafficExchangePayload {
  credits: number;
  idempotencyKey: string;
}

export interface LlmUsageRecord {
  id: string;
  useCaseTag?: string;
  status?: string;
  promptTokens?: string | number | null;
  completionTokens?: string | number | null;
  totalTokens?: string | number | null;
  reservedTokens?: string | number | null;
  settledTokens?: string | number | null;
  freeTokens?: string | number | null;
  createdAt: string;
  model?: { id: string; name: string; modelIdString?: string } | null;
  user?: { id: string; email: string | null; name: string | null } | null;
}

export interface LlmUsageQuery {
  page?: number;
  limit?: number;
}

export interface LlmUsageListResponse {
  data: LlmUsageRecord[];
  pagination?: { page: number; limit: number; total: number; totalPages: number };
}

export interface LlmTrafficConfig {
  tokensPerCredit: string | number;
  /** 每日免费额度 token 数（0 表示关闭） */
  freeDailyTokens?: number;
}

function queryString(query: object) {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== '') params.set(key, String(value));
  });
  return params.toString() ? `?${params.toString()}` : '';
}

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  return readEnvelope<T>(await platformFetch(path, options), '请求失败');
}

/** LLM 流量用户兑换与管理配置客户端。 */
export const llmTrafficAPI = {
  getBalance: () => request<LlmTrafficBalance>('/llm-traffic/balance'),
  exchange: (payload: LlmTrafficExchangePayload) =>
    request<unknown>('/llm-traffic/exchange', { method: 'POST', body: JSON.stringify(payload) }),
  listUsage: (query: LlmUsageQuery = {}) =>
    request<LlmUsageRecord[]>(`/llm-traffic/usages${queryString(query)}`),

  getAdminConfig: () => request<LlmTrafficConfig>('/llm-traffic/admin/config'),
  updateAdminConfig: (payload: LlmTrafficConfig) =>
    request<LlmTrafficConfig>('/llm-traffic/admin/config', { method: 'PUT', body: JSON.stringify(payload) }),
  listAdminUsage: (query: LlmUsageQuery = {}) =>
    request<LlmUsageRecord[]>(`/llm-traffic/admin/usages${queryString(query)}`),
};
